import axios from "axios"
import qs from "qs"

// 添加响应拦截器
axios.interceptors.response.use(
    function(response) {
      // 对响应数据做点什么
    //   console.log(response.data.code,'----response')
    // code为307：登录过期
    // response.data.code==307||
      if(response.data.code==307||response.data.msg=='session失效'){
		// location.href='/test/login'
        location.href='/qjyxWeb-user/login'
      }else{
        return response;
      }
    },
    function(error) {
      // 对响应错误做点什么
      return Promise.reject(error);
    }
  );
async function userPassLogin(params) {          //账号密码登录
    return axios.post("/api/wxApplets/userPassLogin",
        qs.stringify(params)
    )
}

async function queryQrCode(params) {          //生成二维码
    return axios.post("/api/wxApplets/queryQrCode",
        qs.stringify(params)
    )
}

async function getUserInfo(params) {          //获取用户信息
    return axios.post("/api/wxApplets/getUserInfo",
        qs.stringify(params)
    )
}

async function loginOut(params) {          //退出登录
    return axios.post("/api/wxApplets/loginOut",
        qs.stringify(params)
    )
}

async function getUserStudentLi(params) {          //获取所有学生信息
    return axios.post("/api/wxApplets/getUserStudentLi",
        qs.stringify(params)
    )
}

async function changeNowStudent(params) {          //用户切换当前学生信息
    return axios.post("/api/wxApplets/changeNowStudent",
        qs.stringify(params)
    )
}
  
async function queryReportList(params) {          //获取生成报告列表
    return axios.get("/api/report/queryReportList",
        qs.stringify(params)
    )
}

async function queryTermList(params) {          //查询学期
    
    if(params.examFlag===false){
        return axios.get("/fgg/workReport/queryTermList?haveScoreFlag="+params.haveScoreFlag+"&examFlag="+params.examFlag)
    }else{
        return axios.get("/fgg/workReport/queryTermList?haveScoreFlag="+params.haveScoreFlag)
    }
    
    
}

async function queryCourse(params) {          //首页查询科目
    return axios.post("/fgg/workReport/queryCourse",
    qs.stringify(params)
    )
}

async function queryStuExam(params) {          //获取考试列表
    return axios.post("/fgg/stuScoreAnalysis/queryStuExam",
        qs.stringify(params)
    )
}

async function getAllExamType(params) {          //获取考试类型
    return axios.post("/fgg/examController/getAllExamType",
        qs.stringify(params)
    )
}

async function addReport(params) {          //生成PDF报告
    return axios.post("/api/report/addReport",params
    )
}

async function queryExamById(params) {          //通过id获取考试
    return await axios.get("/fgg/stuScoreAnalysis/queryExamById?examId="+params)
}


async function queryExamCourseNew(params) {          //查询单个考试的科目
    return await axios.post("/fgg/stuScoreAnalysis/queryExamCourseNew",
    qs.stringify(params))
}

async function getUserFggPwd(params) {          //获取用户fgg密码
    return axios.post("/api/wxApplets/getUserFggPwd",
        qs.stringify(params)
    )
}


async function loginAjax(params) {          //分高高登录
    return axios.post("/fgg/loginAjaxTrain",
        qs.stringify(params)
    )
}

async function queryQuestionType(params) {          //获取试题类型
    if (params.examId) {
        return axios.get("/fgg/workReport/queryQuestionType?course="+params.course+"&examId="+params.examId)
    }else{
        return axios.get("/fgg/workReport/queryQuestionType?course="+params.course)
    }
   
}

async function queryStuWrongQuestionsExam(params) {          //获取错题本试题
    return axios.post("/fgg/classReportNew/queryStuWrongQuestionsExam",
        qs.stringify(params)
    )
}

async function queryQuestionByQuestionId(params) {          //获取试题详情
    return axios.post("/fgg/generatingPaper/queryQuestionByQuestionId",
        qs.stringify(params)
    )
}

async function queryLoginQrCode(params) {          //获取登录二维码
    return axios.post("/api/wxApplets/queryLoginQrCode",
        qs.stringify(params)
    )
}


async function wxScanCheck(params) {          //获取二维码扫码结果
    return axios.post("/api/wxApplets/wxScanCheck",
        qs.stringify(params)
    )
}

async function querySchool(params) {          //获取当前所在学校
    return axios.get("/fgg/workReport/querySchool",
    qs.stringify(params)
    )
}

async function queryWorkList(params) {          //获取章节树形数据
    return axios.post("/fgg/workReport/queryWorkList",
        qs.stringify(params)
    )
}


export {
    queryWorkList,
    querySchool,
    wxScanCheck,
    queryLoginQrCode,
    queryQuestionByQuestionId,
    queryStuWrongQuestionsExam,
    queryQuestionType,
    loginAjax,
    getUserFggPwd,
    queryExamCourseNew,
    queryExamById,
    addReport,
    getAllExamType,
    queryStuExam,
    queryCourse,
    queryTermList,
    queryReportList,
    changeNowStudent,
    getUserStudentLi,
    loginOut,
    getUserInfo,
    queryQrCode,
    userPassLogin,
}


// WEBPACK FOOTER //
// ./src/api/request.js